export const ADMIN_PENDING_WITHDRAWALS_VIEW_ROUTE_NAME = Symbol('admin.pending-withdrawals.view');

export const PENDING_WITHDRAWALS_ITEM_URL = 'admin/affiliate_cashouts/pending_cashouts/:id';
export const PENDING_WITHDRAWALS_ITEM_QUERY_KEY = 'pending-withdrawals.item';
